<template>
  <div class="km__modules__logo">
    <LogoDefault
        :showlogo_list_button="logoList.length>0"
        @setOpenState="setOpenstate"
    />
    <LogoLibrary v-if="libraryOpen"
                 :logo-library="logoLibraryFunction"
                 @closelibrary="closeModule"
                 @deleteLogoFromPool="deleteLogoFromLogoPool"
    />
    <UserLogoLibrary v-if="userLibraryOpen"
                     :logo-library="logoLibraryFunction"
                     @closelibrary="closeModule"
                     @logochosen="insertLogoOnShirt"
                     @deleteLogoFromPool="deleteLogoFromLogoPool"
    />
    <StockLogoLibrary v-if="stocklogoLibraryOpen"
                      :logo-library="logoLibraryFunction"
                      @closelibrary="closeModule"
                      @logochosen="insertLogoOnShirt"
    />
    <KiLogoLibrary v-if="kilogoLibraryOpen"
                   @closelibrary="closeModule"
    />
    <LogoList
        :logoList="logoList"
        @closeModule="closeModule"
        @deleteLogoElem="deleteLogoElem"
    />
    <LogoEdit
        :currentSelOb="logoObjectToEdit as Logo"
        @close="closeModule"
        @back="backOneLevel"
        @deleteLogoElem="deleteLogoElem"
        @colorPickerClicked="colorPickerClicked"
    />
    <ColorShadeGroupSelection v-if="logoHasColors"
                              containerclass="km__modules__logo--color"
                              :currentColorValueIntOrNONEstring="currentColorValue"
                              :palettenCluster="currentPalettenClusterSorted"
                              :animationkeyframesgetter="colorMainAnimation"
                              @setColor="setCurrentLogoColor"
                              :currentpalette="currentPalette"
    />
    <ModuleColorShade v-if="logoHasColors"
                      containerclass="km__modules__logo--color--shade"
                      :currentColorValueIntOrNONEstring="currentColorValue"
                      :animationkeyframesgetter="colorShadeAnimation"
                      :palettenCluster="currentPalettenClusterSorted"
                      @setColor="setCurrentLogoColor"
                      :currentpalette="currentPalette"
    />
  </div>
</template>

<script lang="ts" setup>
import LogoDefault from "./LogoDefault.vue";
import LogoList from "./LogoList.vue";
import LogoEdit from "./LogoEdit.vue";
import ModuleColorShade from "@km/components/color/ColorShadeSelection.vue";
import ModuleLogoFunctions, {
  getLogoModuleColorMainAnimation,
  getLogoModuleColorShadeAnimation
} from "@km/components/logo/ModuleLogoFunctions";
import {SELOBEVENTNAMES} from "@k/global/GlobalEventnames";
import {Store, useStore} from "vuex";
import {computed, defineAsyncComponent, watch} from "vue";
import {LOGOMODULE_POSSIBLE_STATES} from "@km/components/logo/ModuleLogoAnimationStates";
import {EventListener, EventVerteiler} from "@k/global/eventVerteiler";
import {AnimationWaitingForTargetFactory, KeyFrameTargetValues, OPEN} from "@km/animations/animationFactory";
import ColorShadeGroupSelection from "@km/components/color/ColorShadeGroupSelection.vue";
import {useI18n} from "vue-i18n";
import {ChromoLogo, Logo} from "@k/js/selectableObjects";
import {LogoPoolEntry} from "@k/js/databaseInterfaceClasses";
import {displayYesNoDialog} from "@km/components/popups/ConfirmOrConfirmCancelDialog";
import {useModuleColorOpenStateStore} from "@km/store/frontendstate/useModuleColorOpenState";
import {useModuleLogoOpenStateStore} from "@km/store/frontendstate/useModuleLogoOpenState";
import {usePalettenClusterStore} from "@k/vue/store/palettenClusterStore";


const StockLogoLibrary = defineAsyncComponent(() => import("@km/components/logo/StockLogoLibrary.vue"));
const KiLogoLibrary = defineAsyncComponent(() => import("@km/components/logo/KiLogos.vue"));
const LogoLibrary = defineAsyncComponent(()=>import("@km/components/logo/LogoLibrary.vue"));
const UserLogoLibrary = defineAsyncComponent(()=>import("@km/components/logo/UserLogoLibrary.vue"));


const openStatusStore=  useModuleLogoOpenStateStore();



const store = useStore();
ModuleLogoFunctions.init(store);
const eventListener = new EventListener();

const functions = new ModuleLogoFunctions();
eventListener.addEventListener(
    [SELOBEVENTNAMES.SELECTION_CLEARED, SELOBEVENTNAMES.DELETED, "colorSelectedEvent"],
    () => functions.selObDeSelectedEventHandler(store))
eventListener.addEventListener([SELOBEVENTNAMES.SELECTED], (data) => functions.selObSelectedEventHandler(data, store));
eventListener.addEventListener("selObSelectedFromRahmen", id => ModuleLogoFunctions.selObSelectedFromRahmenEventHandler(id, store))


watch(() => store.getters.LOGOTABisOpen, (isOpen: boolean) => {
  isOpen ? openStatusStore.ensureStateIsNotClosed() :
      openStatusStore.setCurrentState(LOGOMODULE_POSSIBLE_STATES.closed);
  if (!isOpen) {
    if (ModuleLogoFunctions.logoObjectToEdit.value !== null) {
      EventVerteiler.broadcast(SELOBEVENTNAMES.SELECTION_CLEARED);
    }
  }
});
watch(() => openStatusStore.getCurrentState, (state: LOGOMODULE_POSSIBLE_STATES) => {
  // ModuleLogoAnimations.animateToLayer(state)
  if ([LOGOMODULE_POSSIBLE_STATES.logoverwaltung, LOGOMODULE_POSSIBLE_STATES.closed].indexOf(state) > -1) {
    ModuleLogoFunctions.deselectLogoifSelected()
  }
});
const i18n = useI18n();

const logoObjectToEdit = ModuleLogoFunctions.logoObjectToEdit;
const logoList = ModuleLogoFunctions.logoList;
const logoLibraryFunction = ModuleLogoFunctions.logoLibrary;
const palettenStore = usePalettenClusterStore();
const currentPalettenCluster = computed(()=> palettenStore.getPalettenCluster("CM5 Bedruckbar"));
const currentPalettenClusterSorted = computed(() => store.getters.getPalettenClusterSorted(currentPalettenCluster.value));
const currentColorValue = ModuleLogoFunctions.currentColorValue;
const currentPalette = "CM5 owayo Farbsystem";

const setCurrentLogoColor = ModuleLogoFunctions.setCurrentLogoColor;
const setOpenstate = (state) => openStatusStore.setCurrentState(state);
const deleteLogoElem = id => EventVerteiler.broadcast(SELOBEVENTNAMES.DELETEREQUEST, id);
const insertLogoOnShirt = ModuleLogoFunctions.insertLogoOnShirt;
const colorPickerClicked = (color) => functions.colorPickerClicked(color, store);
const closeModule = () => {
  if (openStatusStore.getCurrentState !== LOGOMODULE_POSSIBLE_STATES.closed) {
    openStatusStore.setCurrentState(LOGOMODULE_POSSIBLE_STATES.logoverwaltung)
  }
};
const colorShadeAnimation = getLogoModuleColorShadeAnimation();
const colorMainAnimation = getLogoModuleColorMainAnimation();
const backOneLevel = () => openStatusStore.goUpOneLevel();
const libraryOpen = computed(() => openStatusStore.getLibrarystate === OPEN);
const userLibraryOpen = computed(() => openStatusStore.getUserLibrarystate === OPEN);
const stocklogoLibraryOpen = computed(() => openStatusStore.getStockLogoLibraryState === OPEN);
const kilogoLibraryOpen = computed(() => openStatusStore.getKiLogoLibraryState === OPEN);


const deleteLogoFromLogoPool = (logoPoolEntry: LogoPoolEntry) => {
  displayYesNoDialog(i18n.t("konf_deleteLogo_title"), i18n.t("konf_deleteLogo_message")).then(() => {
    store.dispatch("deleteLogoFromLogoPool", logoPoolEntry);
  }).catch(() => {
  })
};
const logoHasColors = computed(() => ModuleLogoFunctions.logoObjectToEdit.value !== null &&
    (ModuleLogoFunctions.logoObjectToEdit.value as ChromoLogo).colors?.length > 0);

</script>

<style lang="scss" scoped>
//@import "../../scss/transitions.scss";
//@include ypercentTransition;
.km__modules__logo {
  display: block;
}

.maincolorpickercomponent {
  background: white;
}
</style>
